import React, { useEffect, useRef, useState, useContext, createContext } from 'react';
import { Button, Form, Input, Row, Col, message, MainModal, ProTableOt } from "../ui/ot";
import { useNavigate, } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import { PlusOutlined } from "@ant-design/icons";
import { useHoliday } from './controller/use_holiday_controller';
const LanguageContext = createContext(null)
export const daysInHolidayYear = (value) => {
    const year = Number(value)
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 366 : 365
}

const HolidayOverView = ({
    keyPrefix = "shift_management.holiday_overview",
    propsForm,
    customColumns = [],
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }, //selectInfo
    rowKey = "holiday_setting_id",
    propsHolidaySettingApi = "/shift_management/api/holiday/setting",
    propsHolidaySettingNewYearApi = "/shift_management/api/holiday/new_year",
    propsSearchparams,
    propsHolidaySettingNewYearParams,
    propsHolidaySettingNewYearInitialvalue,

}
) => {
    const { t } = useTranslation("translation", { keyPrefix });
    const navigate = useNavigate();
    const actionRef = useRef()
    const [extra_columns, set_extra_columns] = useState([]);
    const [pageSize, setPageSize] = useState(20)
    const [columns] = useState([
        {
            title: `${t('holiday_setting_year')}`,
            key: 'holiday_setting_year',
            dataIndex: 'holiday_setting_year',
            align: 'center',
            sorter: false,
        },
        {
            title: `${t('all_holiday_count')}`,
            key: 'all_holiday_count',
            dataIndex: 'all_holiday_count',
            sorter: false,
            align: 'center',
            render: (text, record, index) => {
                return (
                    <>
                        {text ?? 0}/{daysInHolidayYear(record?.holiday_setting_year)}
                    </>
                )
            }
        },
        ...customColumns,
        {
            title: `${t('action')}`,
            key: 'action',
            dataIndex: 'action',
            align: 'center',
            sorter: false,
            disabled: true,
            render: (text, record, index) => {
                return <Row justify={'center'}>
                    <Col>
                        <Button
                            variant={"ghost"}
                            className="text-blue-600 p-2"
                            onClick={() => {
                                navigate(`./detail?holiday_setting_id=${record?.holiday_setting_id}`)
                            }}
                        >
                            詳細
                        </Button>
                    </Col>
                </Row>
            }
        },

    ]);

    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [axiosMode, setAxiosMode] = useState("get")
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const reload = () => {
        actionRef.current?.reloadAndRest();
    }

    const setParamsFilter = (obj) => {
        //拿掉值為空或是null 的東西
        return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
    }

    const [preview, setPreview] = useState(null)
    const [previewError, setPreviewError] = useState('')
    const [previewLoading, setPreviewLoading] = useState(false)
    const previewRequest = useRef(0)
    const previewParams = { ...propsHolidaySettingNewYearParams }
    const previewKey = JSON.stringify([propsHolidaySettingNewYearApi, previewParams])
    const currentPreviewKey = useRef(previewKey)
    currentPreviewKey.current = previewKey

    const refreshPreview = async () => {
        const requestId = ++previewRequest.current
        const requestKey = previewKey
        setPreviewLoading(true)
        setPreviewError('')
        const result = await getHolidaySettingNewYear(previewParams)
        if (requestId !== previewRequest.current || requestKey !== currentPreviewKey.current) return null
        setPreview(result)
        setPreviewLoading(false)
        return result
    }

    const handleAddRow = () => {
        setAxiosMode("post")
        setPreview(null)
        form.resetFields({ year: '' })
        setModalOpen(true)
        refreshPreview()
    }

    const onFinish = ({ axiosMode, requestType, status, values }) => {
        if (axiosMode === "get") {
            if (requestType === 'preview' && status === 'error') setPreviewError(values?.message || '無法取得年度資料，請關閉後重試。')
            return
        }
        setModalLoading(false)
        if (status === "success") {
            message.success(values?.data?.[0]?.outcome === 'skipped' ? '此年度已存在，保留原設定' :
                axiosMode === 'delete' ? '刪除成功' : '新增成功')
            setModalOpen(false)
            refreshPreview()
            reload()
        } else {
            message.error(values?.message || (axiosMode === 'delete' ? '刪除失敗' : '新增失敗，請稍後再試'))
            reload()
        }
    }

    const onBefore = ({ axiosMode }) => {
        if (axiosMode !== "get") setModalLoading(true)
    }

    const useTableColumnsCheck = (columns) => {
        const [check, setCheck] = useState(() => columns.filter(column => !column.disabled).map(column => column.key))
        const setOrders = (sorter) => {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: 'DESC'
                    })
                }
                else {
                    return JSON.stringify({
                        column: key,
                        type: 'ASC'
                    })
                }

            })
            return newOrders
        }
        return {
            check,
            custom_filter_key: check,
            setCheck,
            setOrders
        }
    }

    const onFormFinish = (values) => {
        if (previewLoading || modalLoading) return
        if (!preview || !/^[1-9][0-9]{3}$/.test(String(preview.year)) || String(values?.year) !== String(preview.year)) {
            message.error('請先取得有效的年度資料')
            return
        }
        return postHolidaySettingData([{
            ...propsHolidaySettingNewYearInitialvalue,
            ...previewParams,
            year: preview.year,
        }])
    }

    const {
        check,
        setCheck,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck(columns)

    const {
        getHolidaySettingNewYear,
        getHolidaySettingData,
        postHolidaySettingData,
        deleteHolidaySettingData
    } = useHoliday({
        mainNewYearApi: propsHolidaySettingNewYearApi,
        mainApi: propsHolidaySettingApi,
        scopeKey: previewKey,
        onBefore: onBefore,
        onFinish: onFinish
    })
    useEffect(() => {
        setModalOpen(false)
        setPreview(null)
        setPreviewError('')
        setPreviewLoading(false)
        setModalLoading(false)
        previewRequest.current += 1
        return () => { previewRequest.current += 1 }
    }, [previewKey]);
    return (
        <Row gutter={[8, 8]}>
            <MainModal
                axiosMode={axiosMode}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}
                propsForm={form}
                propsLoading={modalLoading}
                propsSetLoading={setModalLoading}
                onFinish={onFormFinish}
                formElement={<HolidayForm holidaySettingNewYearDatas={preview} previewLoading={previewLoading} previewError={previewError} />}
            />
            <Col span={24}>
                <Row gutter={[8, 16]}>
                    <Col span={24}>
                        <ProTableOt
                            searchParams={
                                {
                                    ...propsSearchparams
                                }
                            }
                            actionRef={actionRef}
                            columns={columns}
                            check={check}
                            setCheck={setCheck}
                            rowKey={'holiday_setting_id'}
                            selections={{
                                // onChange: (index_, data_) => set_data(data_)
                            }}
                            toolBarRender={() => [
                                <Button
                                    key="add-year"
                                    icon={<PlusOutlined />}
                                    variant={"default"}
                                    onClick={handleAddRow}>
                                    新增年份
                                </Button>
                            ]}
                            extra_columns={extra_columns}
                            set_extra_columns={set_extra_columns}
                            manage_columns={false}
                            request={async (params = {}, sort, filter) => {
                                let newParams = {
                                    ...propsSearchparams
                                };
                                let order = setOrders(sort)
                                newParams = {
                                    ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                    ...newParams,
                                    order,
                                    size: params.pageSize,
                                    cur_page: params.current,
                                    custom_filter_value: params.keyword ?? "",
                                    custom_filter_key: custom_filter_key
                                };
                                newParams = setParamsFilter({
                                    ...newParams,
                                });
                                setPageSize(params?.pageSize ?? 20)
                                return getHolidaySettingData(newParams)
                            }}
                            pageSize={pageSize}
                            scroll={{
                                x: "max-content"
                            }}
                            // rowSelection={false}
                            rowSelection={{
                                ...rowSelection,
                                type: 'checkbox',
                                selectedRowKeys: selectedRowKeys,
                                selectedRowsInfo: selectedRowsInfo,
                                setSelectedRowKeys: setSelectedRowKeys,
                                setSelectedRowsInfo: setSelectedRowsInfo,
                            }}
                            propsDelete={true}
                            propsUseData={() => {
                                return {
                                    deleteData: (data) => {
                                        deleteHolidaySettingData(data)
                                    }
                                }
                            }}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}



export const HolidayForm = ({
    keyPrefix = "shift_management.holiday_overview",
    propsForm,
    open = false,
    holidaySettingNewYearDatas = null,
    previewLoading = false,
    previewError = '',
    onFormFinish = () => { },
}) => {
    const keyPrefix_ = useContext(LanguageContext)
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    const [internalForm] = Form.useForm()
    const form = propsForm || internalForm
    const year = holidaySettingNewYearDatas?.year
    useEffect(() => {
        if (open) form.resetFields({ year: year == null ? '' : String(year) })
    }, [open, year, form])
    return <Form form={form} onFinish={onFormFinish} autoComplete="off">
        <Form.Item name="year" label={t('input_year')} disabled={true}
            rules={[{ required: true, message: '請先取得有效的年份' }]}>
            <Input />
        </Form.Item>
        <div role="status">
            {previewLoading ? '讀取年度資料中…' : !holidaySettingNewYearDatas ? (previewError || '無法取得年度資料，請關閉後重試。') :
                holidaySettingNewYearDatas.source_status && holidaySettingNewYearDatas.source_status !== 'ready'
                    ? '尚無完整年度日曆，新增時會下載並驗證來源；無法取得時不會建立年度。'
                    : `${t('total_public_holiday')}：${holidaySettingNewYearDatas.holiday_count ?? holidaySettingNewYearDatas.total ?? 0} 天`}
        </div>
    </Form>
}
export default HolidayOverView;
